// insert something in between every element of an array
export const interleave = (array, insertion) =>
  array.flatMap(x => [insertion, x]).slice(1)
